<template>
  <v-dialog
    v-model="dialog"
    width="600"
    open-on-focus
    no-click-animation
    persistent
    content-class="exercise-share-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="exercise-share-form" @submit.prevent="onSubmit">
        <div class="exercise-share-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="exercise-share-toolbar-title">Share to company</v-toolbar-title>
            <v-spacer></v-spacer>
            <dialog-select
              name="status"
              :items="statusFilters"
              :value="true"
              placeholder="Status"
              customClass="filter"
              itemText="label"
              itemValue="value"
              @input="filterStatus"></dialog-select>
            <v-btn
              color="accent"
              rounded
              elevation="0"
              @click="selectAll"
            >
              Select all
            </v-btn>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="new-practice-card-container">
            <bh-text-input
              :no-margin="true"
              higher
              placeholder="Search company"
              inputBackgroundClass="bhWhite"
              roundedClass="rounded"
              @input-text="searchRun" />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <div class="exercise-share-patients">
              <main-user-table
                :headers="headers"
                :items="computedPractices"
                :items-per-page="queryParams.pageSize"
                :server-items-length="pagination.totalCount || -1"
                :page="queryParams.page"
                :row-component="'choose-practice-table-row'"
                @to-user="selectPractice"
                @action:get-data="(data) => (getDataAction({ ...data, isActive: status }, false))"
              />
            </div>
          </v-container>
        </div>
        <div class="exercise-share-footer">
          <v-container class="pt-0 pb-4">
            <v-row>
              <v-col class="text-right">
                <v-btn :disabled="!formIsValidCheck" elevation="0" rounded color="accent" @click="sharePractices">Assign</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MainUserTable from "@/components/tables/MainUserTable"
import BhTextInput from "@/components/inputs/BhTextInput.vue"
import RouterMixin from "@/mixins/router"
import DialogSelect from "@/components/forms/DialogSelect"
import { debounce } from '@/helpers/debounce'

export default {
  name: 'ExerciseShareDialog',
  components: {
    MainUserTable,
    BhTextInput,
    DialogSelect,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  mixins: [RouterMixin],
  data () {
    return {
      dialog: false,
      headers: [],
      selectedPractices: [],
      formIsValidCheck: false,
      statusFilters: [{label: 'Active', value: true}, {label: 'Active & Inactive', value: null}],
      status: 1,
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        this.getDataAction({ ...this.defaultQueryParams, isActive: this.status }, false)
      }
    }
  },
  computed: {
    ...mapState('practicesStates', [
      'practices',
      'pagination'
    ]),
    computedPractices () {
      let practices = []
      this.practices.forEach(item=>{
        let selected = false
        if (this.selectedPractices.includes(item.id)) selected = true
        practices.push({selected: selected, ...item})
      })
      return practices
    },
  },
  methods: {
    ...mapActions('practicesStates', [
      'getPractices'
    ]),
    getData(data = {}) {
      if (this.dialog) this.getPractices(data);
    },
    closeDialog () {
      this.dialog = false
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    clearForm () {
      this.$refs.form.reset()
    },
    onSubmit () {
      this.$emit('on-submit', this.selectedPractices)
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.closeDialog()
    },
    searchRun(text) {
      debounce(()=>{
        this.getDataAction({ ...this.queryParams, name: text }, false)
        this.selectedPractices = []
        this.formIsValid()
      }, 500, 'getPractices')
    },
    selectPractice({id, value}) {
      debounce(()=>{
        if (!this.singleChoose) {
          let i = this.selectedPractices.indexOf(id)
          if (value==0) {
            if (i !== -1) {
              this.selectedPractices.splice(i, 1)
            }
          } else {
            if (i==-1)
            this.selectedPractices.push(id)
          }
        } else {
          if (value==0)
            this.selectedPractices = []
          else this.selectedPractices = [id]
        }
        this.formIsValid()
      },100, 'selectPractice')
    },
    setDate({id, value}) {
      this.sequenceStartDate = value
      this.formIsValid()
    },
    formIsValid() {
      if (this.selectedPractices.length==0) this.formIsValidCheck = false
      else this.formIsValidCheck = true
    },
    sharePractices() {
      if (this.formIsValidCheck) this.$emit('share-practices', this.selectedPractices)
    },
    getPracticesAction(data) {
      debounce(()=>{
        this.getDataAction({... this.queryParams, ...data}, false)
      }, 500, 'getPractices')
    },
    selectAll() {
      this.selectedPractices = this.computedPractices.map(practice=>{
        return practice.id
      })
      this.formIsValid()
    },
    filterStatus(status){
      this.status = status.value
      this.getDataAction({ ...this.queryParams, isActive: status.value }, false)
      this.selectedPractices = []
      this.formIsValid()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.exercise-share {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    // display: flex;
    // flex-direction: column;
    // background-color: red !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }
    .dialog-select.filter {
      flex-grow: 0;
      max-width: 180px;
      margin-right: 8px;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-weight: bold;
  }
  &-tabs {
    padding:0 24px;
    background:#ffffff;
    .v-tab {
      color:$bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color:white;
      }
    }
    .v-tabs-slider {
      background:$bh-blue;
    }
  }
  &-v-tabs-items {
    background:$bh-blue--4 !important;
  }

  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-form {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 0;
    &-body {
      display: flex;
      flex-direction: column;
      height: auto;
      flex-shrink: 1;
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
  &-user-patients {
    padding: 12px 24px;
  }
}
</style>
